'use client';

import FaIcon, { faChevronDown, faChevronUp } from '@/components/icon/FaIcon/FaIcon';
import Accordion from '@/components/ui/Accordion/Accordion';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { scrollIntoTheView } from '@/utils/functions';
import { useAtom } from 'jotai';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { localeAtom } from '../../atoms/localAtom';
import { pickText } from '../../utils/pickText';
import styles from './LotteryDetailDescription.module.scss';

function LotteryDetailDescription({
  precautions,
  description,
  shippingDescription,
  benefitDescription,
  wChanceDescription,
  precautions_en,
  description_en,
  shippingDescription_en,
  benefitDescription_en,
  wChanceDescription_en,
  descriptionTitle = 'くじ詳細',
  descriptionTitle_en = 'Lottery Details',
  howToId,
  isDefaultOpen = false,
  isFamikuji = false,
}: {
  precautions: string;
  description: string;
  shippingDescription: string;
  benefitDescription?: string;
  wChanceDescription?: string;
  precautions_en?: string;
  description_en?: string;
  shippingDescription_en?: string;
  benefitDescription_en?: string;
  wChanceDescription_en?: string;
  descriptionTitle?: string;
  descriptionTitle_en?: string;
  howToId?: string;
  isDefaultOpen?: boolean;
  isFamikuji?: boolean;
}) {
  const [locale] = useAtom(localeAtom);
  const [isOpened, setIsOpened] = useState(isDefaultOpen);
  const [transLateItem, setTransLateItem] = useState({
    title: '',
    description: '',
    precautions: '',
    shippingDescription: '',
    benefitDescription: '',
    wChanceDescription: '',
  });

  useEffect(() => {
    setTransLateItem({
      title: pickText(locale, descriptionTitle, descriptionTitle_en ?? ''),
      description: pickText(locale, description, description_en ?? ''),
      precautions: pickText(locale, precautions, precautions_en ?? ''),
      shippingDescription: pickText(locale, shippingDescription, shippingDescription_en ?? ''),
      benefitDescription: pickText(locale, benefitDescription ?? '', benefitDescription_en ?? ''),
      wChanceDescription: pickText(locale, wChanceDescription ?? '', wChanceDescription_en ?? ''),
    });
  }, [locale]);

  const toggleAccordion = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsOpened(!isOpened);
  };
  const goHowTo = (e: React.MouseEvent, targetId: string) => {
    e.preventDefault();
    scrollIntoTheView(targetId);
  };
  return (
    <>
      <div className={styles.componentStyle}>
        <p className={`${utilsStyles.textLarge} ${utilsStyles.textBold}`}>{transLateItem.title}</p>
        <hr className={styles.itemHr} />
        <div className={utilsStyles.textSmall}>
          <Accordion isOpened={isOpened} startHeight={50}>
            <div
              className={`${utilsStyles.textPrewrap} ${utilsStyles.textHtml}`}
              // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
              dangerouslySetInnerHTML={{ __html: transLateItem.description }}
            />
            {precautions && (
              <>
                <p className={`${utilsStyles.mtXSmall} ${utilsStyles.textMedium}`}>
                  <b>{locale === 'en' ? 'Precautions' : '注意事項'}</b>
                </p>
                <div
                  className={`${utilsStyles.textPrewrap} ${utilsStyles.textHtml}`}
                  // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                  dangerouslySetInnerHTML={{ __html: transLateItem.precautions }}
                />
              </>
            )}
            {shippingDescription && (
              <>
                <p className={`${utilsStyles.mtXSmall} ${utilsStyles.textMedium}`}>
                  <b>{locale === 'en' ? 'Shipping Instructions' : '配送について'}</b>
                </p>
                <div
                  className={`${utilsStyles.textPrewrap} ${utilsStyles.textHtml}`}
                  // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                  dangerouslySetInnerHTML={{ __html: transLateItem.shippingDescription }}
                />
              </>
            )}
            {benefitDescription && (
              <>
                <p className={`${utilsStyles.mtXSmall} ${utilsStyles.textMedium}`}>
                  <b>{locale === 'en' ? 'Explanation of benefits' : '特典について'}</b>
                </p>
                <div
                  className={`${utilsStyles.textPrewrap} ${utilsStyles.textHtml}`}
                  // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                  dangerouslySetInnerHTML={{ __html: transLateItem.benefitDescription }}
                />
              </>
            )}
            {wChanceDescription && (
              <>
                <p className={`${utilsStyles.mtXSmall} ${utilsStyles.textMedium}`}>
                  <b>{locale === 'en' ? 'Explanation of benefits' : 'Wチャンス賞について'}</b>
                </p>
                <div
                  className={`${utilsStyles.textPrewrap} ${utilsStyles.textHtml}`}
                  // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                  dangerouslySetInnerHTML={{ __html: transLateItem.wChanceDescription }}
                />
              </>
            )}
          </Accordion>

          <div className={utilsStyles.centered}>
            {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
            <a
              href='#'
              onClick={(e) => {
                toggleAccordion(e);
              }}
            >
              {locale === 'en' ? 'show more' : 'もっと見る'}
            </a>
            {isOpened ? <FaIcon icon={faChevronUp} /> : <FaIcon icon={faChevronDown} />}
          </div>
        </div>
      </div>
      {howToId && (
        <div className={`${utilsStyles.mtSmall} ${utilsStyles.textLink}`}>
          <Link
            href='#'
            onClick={(e) => {
              goHowTo(e, howToId);
            }}
          >
            {isFamikuji ? 'くじの遊び方はコチラ' : 'RAFFLEの利用方法はコチラ'}
          </Link>
        </div>
      )}
    </>
  );
}

export default LotteryDetailDescription;
